import React from 'react';
import { SchedulerStatus } from '../../../../functions/agent/date/SchedulerStatus';
import { ShowReason } from '../timelineUtils/ShowReason';
import { ShowReview } from '../timelineUtils/ShowReview';

interface StepComponentProps {
    title: React.ReactNode;
    description?: string;
    addTitle?: string;
    process: number;
    currentProcess: number;
    statuses: string[];
    rejectReason?: string;
    negotiationReason?: string;
    unitKeyStatus?: string
    task?: any;
    feedbackDescription?: string
    reviewDescription?: string
}

export const StepComponent: React.FC<StepComponentProps> = ({ title, addTitle, description, process, currentProcess, statuses, rejectReason, negotiationReason, unitKeyStatus, task, feedbackDescription, reviewDescription }) => {

    return (
        <div>
            <div className={`lh-sm fs-6 ${currentProcess !== process ? "text-gray-600  mt-1" : ""} mb-1`}>{title}</div>
            {addTitle?.trim() ? <div className='lh-sm mb-1 fs-7'> {addTitle} </div> : null}
            {currentProcess === process &&
                <>
                    <div className={'d-flex align-items-center my-1 lh-1'}>
                        <div className=" fw-bold border-light-dark text-bold text-dark me-2 fs-7">Status</div>
                        <div className="">{currentProcess === process ? SchedulerStatus(statuses?.includes('Rescheduled by other agent') ? (task.type === 'MY UNIT' ? ['Rescheduled by yourself'] : ['Rescheduled by other agent']) : statuses?.includes('Rescheduled by agent') ? (task.type === 'MY UNIT' ? ['Rescheduled by other agent'] : ['Rescheduled by yourself']) : statuses ?? [], 'fs-8') : undefined}</div>
                        {/* SchedulerStatus(statuses ?? [], 'fs-8') */}
                    </div>
                    {description && <div className={'d-flex flex-column my-2 lh-1'}>
                        {/* <div className=" fw-bold border-light-dark text-bold text-dark me-2 fs-7">Description: </div> */}
                        <div className="fs-7  ">{description}</div>
                    </div>}
                </>
            }
            {currentProcess === process && rejectReason && (statuses?.includes('Rejected') ||
                statuses?.includes('Slip rejected') ||
                statuses?.includes('A Form rejected') ||
                statuses?.includes('Ads removing rejected') ||
                statuses?.includes('Resubmit required') ||
                statuses?.[0]?.includes?.('Rescheduled')) &&
                <ShowReason statuses={statuses} reason={rejectReason} />
            }
            {(statuses?.[0]?.includes?.('Negotiated') || statuses?.includes('Waiting draft contract send')) && negotiationReason &&
                <ShowReason statuses={statuses} reason={negotiationReason} />
            }
            {unitKeyStatus && currentProcess === process &&
                <div className={'d-flex align-items-center my-1 lh-1'}>
                    <div className=" fw-bold border-light-dark text-bold text-dark me-2 fs-7">Key status</div>
                    <div className="">{currentProcess === process ? SchedulerStatus([unitKeyStatus ?? '']) : undefined}</div>
                </div>
            }
            {feedbackDescription &&
                <ShowReview title={'Your feedback'} description={feedbackDescription} />
            }
            {reviewDescription &&
                <ShowReview title={'BSO Review'} description={reviewDescription} />
            }

        </div>
    );
};

export default StepComponent;





// {
//     title: (
//         <div>
//             <div className='lh-sm mb-1'> {stepDropUpDateKeysBSO} </div>
//             <div className={'d-flex align-items-center'}>
//                 {process === 3 && <div
//                     className="fs-6 lh-1 fw-bold border-light-dark text-bold text-dark me-2">Status key</div>}
//                 <div
//                     className="subTitle">{process === 3 ? SchedulerStatus([unitKeyStatus ?? '']) : undefined}</div>
//             </div>    </div>
//     ),
//     description: descriptionDropUpDateKeysBSO
// },
//     {
//         title: (
//             <div>
//                 <div className='lh-sm mb-1'> {stepDropUpDateKeysBSO} </div>
//                 <div className={'d-flex align-items-center'}>
//                     {process === 3 && <div
//                         className="fs-6 lh-1 fw-bold border-light-dark text-bold text-dark me-2">Status key</div>}
//                     <div
//                         className="subTitle">{process === 3 ? SchedulerStatus([unitKeyStatus ?? '']) : undefined}</div>
//                 </div>    </div>
//         ),
//         description: descriptionDropUpDateKeysBSO
//     },